import { Providers } from "providers/Providers";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { ReviewPage } from "pages/ReviewPage/ReviewPage";
import { UnknownPage } from "pages/UnknownPage/UnknownPage";
import "./App.css";

export const App = () => (
	<Providers>
		<BrowserRouter>
			<Routes>
				<Route path="/:hash" element={<ReviewPage />} />
				<Route path="*" element={<UnknownPage />} />
			</Routes>
		</BrowserRouter>
	</Providers>
);
